import { Outlet } from "react-router-dom";
import { Navbar } from "@components/Navbar";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import SpinnerOverlay from "@components/ui/SpinnerOverlay";
import Chatbot from "@/components/Chatbot";

export function PublicNavbarOnlyLayout() {
  const isFetching = useIsFetching({
    predicate: (query) => !query.meta?.suppressGlobalLoader
  });
  const isMutating = useIsMutating({
    predicate: (mutation) => !mutation.meta?.suppressGlobalLoader
  });
  const isLoading = isFetching > 0 || isMutating > 0;

  return (
    <>
      {isLoading && <SpinnerOverlay />}
      <Navbar />
      <main className="pt-20 lg:pt-0 flex-1 flex flex-col">
        <Outlet />
      </main>
      {/* <Chatbot /> */}
    </>
  );
}
